import $ from '@vaersaagod/tools/Dom';

const destroy = () => {

};

const openShareWindow = (href, width = 600, height = 600) => {
    const left = (window.screen.width / 2) - (width / 2);
    const top = (window.screen.height / 2) - (height / 2);
    window.open(href, 'shareWindow', `height=${height},width=${width}, top=${top},left=${left},toolbar=no,menubar=no,scrollbars=no,resizable=no,location=no,directories=no,status=no`);
};

const init = () => {
    console.log('Sharelinks.init');
    $('a[data-copy-url]').on('click', e => {
        e.preventDefault();
        navigator.clipboard.writeText(window.location.href);
    });

    $('a[data-share-link]').on('click', e => {
        e.preventDefault();
        openShareWindow(e.triggerTarget.href);
    });

    $('a[data-share-mobile]').on('click', e => {
        e.preventDefault();
        try {
            navigator.share({
                url: window.location.href,
                title: document.title
            });
        } catch (error) {
            // console.log(error);
        }
    });
};

export default {
    init,
    destroy
};



// WEBPACK FOOTER //
// ./src/js/components/ShareLinks.js